// components/ProgressBar.tsx
import React from "react";
import Styles from "../../components/Reusable/Forms/BusinessDescriptionForm.module.css";
import Circle from "../../assets/SVGs/hollow_circle.svg";
import Progress from "../../assets/SVGs/form_progress.svg";
import Check from "../../assets/SVGs/green_check.svg";

interface ProgressBarProps {
  steps: string[];
  activeStep: number;
  formStatus: { [key: string]: string };
}

const ProgressBar: React.FC<ProgressBarProps> = ({ steps, activeStep, formStatus }) => {
  // Map steps to their corresponding status keys
  const stepStatusKeys = steps.map((step) => {
    switch (step) {
      case "Business Description":
        return "bd_stage";
      case "Job Hierarchy":
        return "job_hie_stage";
      case "KPI Basket":
        return "kpi_basket_stage";
      case "Critical Matrix":
        return "critical_matrix_stage";
      case "SLA":
        return "sla_stage";
      default:
        return "";
    }
  });

  return (
    <div className={Styles.formActivityBg}>
      <div className={Styles.formActivityBar}>
        <div
          className={Styles.background}
          style={{
            width: `${((activeStep + 1) * 100) / steps.length}%`,
          }}
        />
        {steps.slice(0, -1).map((step, index) => {
          const statusKey = stepStatusKeys[index]; // Get the status key for the current step
          const status = formStatus[statusKey]; // Get the status from formStatus

          return (
            <button
              key={index}
              className={`${Styles.button} ${index === activeStep
                ? Styles.buttonActive
                : Styles.buttonInactive
                } ${status === "Completed" ? Styles.completed : ""
                }`}
            >
              <span className={Styles.iconWrapper}>
                {status === "Completed" ? (
                  <img src={Check} alt="Completed check icon" />
                ) : index === activeStep ? (
                  <img src={Progress} alt="Form Progress" />
                ) : (
                  <img src={Circle} alt="Form Progress" />
                )}
              </span>
              <span className={Styles.stepText}>
                {index + 1}. {step} <br />
                {status ? ( // Only display status if it exists
                  <p style={{ textAlign: 'center', color: status === "Completed" ? '#058B2B' : '#697077' }}>
                    {status}
                  </p>
                ) : null} {/* Display nothing if status is null or empty */}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;